module.exports = __webpack_public_path__ + "static/action-hour.ff9ba583.png";